import { OptionsObject, useSnackbar, WithSnackbarProps } from 'notistack';
import React from 'react';

let useSnackbarRef: WithSnackbarProps;
export const SnackbarUtilsConfigurator: React.FC = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

export default {
  success(msg: string) {
    this.toast(msg, { variant: 'success' });
  },
  warning(msg: string) {
    this.toast(msg, { variant: 'warning' });
  },
  info(msg: string) {
    this.toast(msg, { variant: 'info' });
  },
  error(msg: string) {
    this.toast(msg, { variant: 'error' });
  },
  toast(msg: string, options?: OptionsObject) {
    useSnackbarRef.enqueueSnackbar(msg, options);
  },
};
